import React from 'react'
import ExpiredCertificationTable from '../components/expired certifications/expire certification table/ExpiredCertificationTable'
 

const ExpiredCertificationPage = () => {
  return (
    <div>
      <ExpiredCertificationTable/>
    </div>
  )
}

export default ExpiredCertificationPage
